import Vue from 'vue'
import Vuex from 'vuex'
import dict from './modules/dict'
import user from './modules/user'
Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    dict,
    user,
  },
  state: {
  },
  getters: {
  },
  mutations: {
  },
  actions: {
  }
})